(function () {
  function initPeekSlideshow(section) {
    if (!section || section.dataset.initialized === 'true') return;

    const track = section.querySelector('[data-peek-track]');
    const slides = Array.from(section.querySelectorAll('[data-peek-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-peek-dot]'));
    const prev = section.querySelector('[data-peek-prev]');
    const next = section.querySelector('[data-peek-next]');

    if (!track || slides.length === 0) return;

    section.dataset.initialized = 'true';

    let current = 0;
    let autoplayTimer = null;

    function updateDots() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
    }

    function scrollTrackToCurrent(behavior) {
      const slide = slides[current];

      const slideLeft = slide.offsetLeft;
      const slideWidth = slide.offsetWidth;
      const trackWidth = track.clientWidth;

      const targetLeft = slideLeft - (trackWidth / 2) + (slideWidth / 2);

      track.scrollTo({
        left: targetLeft,
        behavior: behavior || 'smooth'
      });

      updateDots();
    }

    function goTo(index) {
      if (index < 0) {
        current = slides.length - 1;
      } else if (index >= slides.length) {
        current = 0;
      } else {
        current = index;
      }

      scrollTrackToCurrent('smooth');
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.peekDot));
      });
    });

    function startAutoplay() {
      if (section.dataset.autoplay !== 'true' || slides.length < 2) return;

      stopAutoplay();

      const speed = Number(section.dataset.speed) || 5000;

      autoplayTimer = window.setInterval(function () {
        goTo(current + 1);
      }, speed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('touchstart', stopAutoplay, { passive: true });
    section.addEventListener('touchend', startAutoplay);

    window.addEventListener('resize', function () {
      updateDots();
    });

    updateDots();
    startAutoplay();
  }

  function initAllPeekSlideshows() {
    document.querySelectorAll('[data-peek-slideshow]').forEach(function (section) {
      initPeekSlideshow(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllPeekSlideshows);

  document.addEventListener('shopify:section:load', function (event) {
    initPeekSlideshow(event.target.querySelector('[data-peek-slideshow]'));
  });
})();